import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment/moment";
import { Card, Spin } from "antd";

const AgencyFeedback = ({ data }) => {
    const { token } = useSelector((state) => state.auth);
    const [feedbacks, setFeedbacks] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchFeedback = async () => {
            if (!data?.id || !token) return;
            setLoading(true);
            try {
                const response = await axios.get(`portfolio/feedback-details/${data.id}/`, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                });
                
                console.log("Agency feedback API Response:", response.data);
                
                // Handle different possible structures (array or object containing list)
                const resData = response.data?.data || response.data;
                if (resData) {
                    if (Array.isArray(resData)) {
                        setFeedbacks(resData);
                    } else if (resData.telecaller_feedback && Array.isArray(resData.telecaller_feedback)) {
                        setFeedbacks(resData.telecaller_feedback);
                    } else if (Array.isArray(resData.feedback)) {
                        setFeedbacks(resData.feedback);
                    } else {
                        setFeedbacks([]);
                    }
                }
            } catch (error) {
                console.error("Error fetching agency feedback details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchFeedback();
    }, [data?.id, token]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '50px' }}>
                <Spin size="large" />
            </div>
        );
    }

    if (!feedbacks || feedbacks.length === 0) {
        return (
            <div className="customerLoanInfoContainer" style={{ padding: '30px', textAlign: 'center' }}>
                <h3 style={{ color: '#8c8c8c', margin: 0 }}>No Feedback Available</h3>
            </div>
        );
    }

    return (
        feedbacks.map((item, index) => {
            return (
                <div key={index} className="customerLoanInfoContainer">
                    <div className="feedbackHeader">
                        <h2 className="feedbackTitle">Feedback {index + 1}</h2>
                    </div>
                    <div className="InfoContainerBox">
                        <div className="detailInfoSect marginBtm">
                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Date</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">
                                        {item?.date ? moment(item.date).format('MM-DD-YYYY') : '' || "N/A"}
                                    </p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Call Status</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.call_status?.value || item.call_status || "N/A"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Sub-status</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.call_sub_status || "—"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Attended By</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.call_attend_by || "—"}</p>
                                </div>
                            </div>
                        </div>

                        <div className="detailInfoSect topPadding">
                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Comment</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.comment || "—"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Notes</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.notes || "—"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Paid Amount</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">₹{item.paid_amount || "0"}</p>
                                </div>
                            </div>

                            <div className="cardOuterBox">
                                <div className="titleSect_1">
                                    <h5 className="header_Text">Bucket ID</h5>
                                </div>
                                <div className="infoSect_1">
                                    <p className="info_Text">{item.xbucket || "—"}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        })
    );
};

export default AgencyFeedback;
